import React, { useEffect, memo } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { updateImage, updateSelectedComponentType } from "../../../../redux/slices/userActivity";
import { convertLinkToDataUrl } from "../../../../utils";

function Image({ styles, src, image_data, update }) {
  const dispatch = useDispatch();

  const { selectedUserActivity } = useSelector((state) => state.userActivity);
  const handleClick = () => {
    dispatch(
      updateSelectedComponentType({
        type: "image",
        name: "image",
      })
    );
  };

  // function toDataUrl(url, callback) {
  //   if (src === null) return;
  //   var xhr = new XMLHttpRequest();
  //   xhr.onload = function () {
  //     var reader = new FileReader();
  //     reader.onloadend = function () {
  //       callback(reader.result);
  //       dispatch(
  //         updateImage({
  //           selectedActivityIdx: selectedUserActivity,
  //           name: "test.png",
  //           uri: reader.result,
  //         })
  //       );
  //     };
  //     reader.readAsDataURL(xhr.response);
  //   };
  //   xhr.open("GET", url);
  //   xhr.responseType = "blob";
  //   xhr.send();
  // }

  useEffect(() => {
    if(!src) return
    convertLinkToDataUrl(src, (result) => {
      if(!result) return
      dispatch(
        updateImage({
          selectedActivityIdx: selectedUserActivity,
          name: "test.png",
          uri: result,
        })
      );
    })
  }, []);

  return (
    <div
      style={{
        ...styles.imageContainer,
        display: "flex",
        justifyContent: "center",
      }}
      onClick={handleClick}
    >
      {image_data !== undefined ? (
        <img
          src={image_data.uri}
          onLoad={update}
          style={{
            borderRadius: "24px",
            cursor: "pointer",
            ...styles.image,
          }}
        />
      ) : (
        <img
          src={src}
          onLoad={update}
          style={{
            borderRadius: "24px",
            cursor: "pointer",
            ...styles.image,
          }}
        />
      )}
    </div>
  );
}

export default Image